<template>
    <q-card
        flat bordered
        class="col-6"
        style="height:100%"
        >
            <q-card-section
            class="q-pa-sm row justify-between items-center bg-primary text-white text-bold"
            >Carrier Notes {{`${context === 'book' ? ' (Optional)' : ''}`}}
            </q-card-section>
            <q-separator />
            <q-card-section>
            <app-editable-input
                :loadingData="loadingData"
                :data="value.note"
                :readonly="isReadOnlyField"
                type="textarea"
                :placeholder="carrierNotePlaceholder"
                name="note"
                @input="handleChangeInput"
                autogrow
            />
            </q-card-section>
    </q-card>
</template>
<script>
import AppEditableInput from '@client/components/form/editable-input';

export default {
  name: 'AppCarrierNoteInput',
  components: {
    AppEditableInput
  },
  props: {
    loadingData: {
      type: Boolean,
      default: false
    },
    value: Object,
    context: {
      type: String,
      default: 'quote'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Object,
      default: function () {
        return {};
      }
    },
    action: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
    carrierNotePlaceholder:
        'Alert us of any information about your transport. Flight date, Moving date, Auction info, Dealership, Hours of operation, Inoperable, Low clearance, Lift or dually, Height over 7ft, ETC'
    };
  },
  computed: {
    isReadOnlyField() {
      if (this.saving.batch) return true;
      return this.readonly || this.action === 'view';
    }
  },

  methods: {
    handleChangeInput(value) {
      const { name, model } = value;
      this[name] = model;
      this.$emit('input', {
        ...this.value,
        [name]: model
        });
    }
  }
};
</script>
<style scoped>
  .q-input-order {
    margin-bottom: 20px;
  }
</style>
